/* ArcDroid 3.0 — predictive search (+ collection sort auto-submit).
   Loaded `defer` on every page from theme.liquid. Vanilla JS, no dependencies.
   Delegates on [data-predictive-input] so it works for the header / mobile-menu
   search and the search-page / 404 inputs alike. The dropdown panel is created
   on demand inside the nearest [data-predictive-wrap]. */
(function () {
  'use strict';

  var DEBOUNCE_MS = 250;
  var MIN_CHARS = 2;
  var debounceTimer = null;
  var controller = null;
  var panelSeq = 0;

  function getWrap(el) {
    return el && el.closest ? el.closest('[data-predictive-wrap]') : null;
  }

  function getInput(wrap) {
    return wrap ? wrap.querySelector('[data-predictive-input]') : null;
  }

  function getPanel(wrap, create) {
    if (!wrap) return null;
    var panel = wrap.querySelector('[data-predictive-panel]');
    if (!panel && create) {
      panelSeq += 1;
      panel = document.createElement('div');
      panel.className = 'predictive__panel';
      panel.setAttribute('data-predictive-panel', '');
      panel.id = 'PredictivePanel-' + panelSeq;
      panel.hidden = true;
      wrap.appendChild(panel);
      var input = getInput(wrap);
      if (input) {
        input.setAttribute('role', 'combobox');
        input.setAttribute('aria-expanded', 'false');
        input.setAttribute('aria-controls', panel.id);
        input.setAttribute('aria-autocomplete', 'list');
      }
    }
    return panel;
  }

  function openPanel(wrap, html) {
    var panel = getPanel(wrap, true);
    var input = getInput(wrap);
    panel.innerHTML = html;
    if (!panel.querySelector('.predictive__results')) {
      closePanel(wrap);
      return;
    }
    panel.hidden = false;
    if (input) input.setAttribute('aria-expanded', 'true');
  }

  function closePanel(wrap) {
    if (!wrap) return;
    var panel = wrap.querySelector('[data-predictive-panel]');
    var input = getInput(wrap);
    if (panel) {
      panel.hidden = true;
      panel.innerHTML = '';
    }
    if (input && input.hasAttribute('aria-expanded')) {
      input.setAttribute('aria-expanded', 'false');
    }
  }

  function closeAll(except) {
    var wraps = document.querySelectorAll('[data-predictive-wrap]');
    for (var i = 0; i < wraps.length; i += 1) {
      if (wraps[i] !== except) closePanel(wraps[i]);
    }
  }

  function endpoint(input) {
    return (
      input.getAttribute('data-predictive-url') ||
      (window.ArcDroid && window.ArcDroid.predictiveSearchUrl) ||
      '/search/suggest'
    );
  }

  function fetchSuggestions(input) {
    var wrap = getWrap(input);
    if (!wrap) return;
    var q = input.value.trim();
    if (q.length < MIN_CHARS) {
      closePanel(wrap);
      return;
    }
    if (controller) controller.abort();
    controller = new AbortController();
    var url =
      endpoint(input) +
      '?q=' + encodeURIComponent(q) +
      '&resources[type]=product,query,page' +
      '&section_id=predictive-search';
    fetch(url, { signal: controller.signal })
      .then(function (res) {
        if (!res.ok) throw new Error('Predictive search HTTP ' + res.status);
        return res.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var section = doc.getElementById('shopify-section-predictive-search') || doc.body;
        openPanel(wrap, section.innerHTML);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        closePanel(wrap);
      });
  }

  /* ── Typing → debounced fetch ── */
  document.addEventListener('input', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('[data-predictive-input]')) return;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      fetchSuggestions(input);
    }, DEBOUNCE_MS);
  });

  /* ── Keyboard: roving focus through result links ──
     ArrowDown/ArrowUp move focus, Escape closes and returns focus to the
     input, Enter is native (submits the form from the input, follows the
     focused link inside the panel). */
  document.addEventListener('keydown', function (e) {
    var wrap = getWrap(e.target);
    if (!wrap) return;
    var panel = wrap.querySelector('[data-predictive-panel]');
    var input = getInput(wrap);
    if (!panel || panel.hidden) {
      if (e.key === 'Escape') closePanel(wrap);
      return;
    }

    if (e.key === 'Escape') {
      e.preventDefault();
      closePanel(wrap);
      if (input) input.focus();
      return;
    }

    var items = panel.querySelectorAll('a.predictive__item');
    if (!items.length) return;
    var idx = -1;
    for (var i = 0; i < items.length; i += 1) {
      if (items[i] === document.activeElement) {
        idx = i;
        break;
      }
    }

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      var next = idx === -1 ? items[0] : items[Math.min(idx + 1, items.length - 1)];
      next.focus();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (idx <= 0) {
        if (input) input.focus();
      } else {
        items[idx - 1].focus();
      }
    }
  });

  /* ── Dismiss when interacting outside the active wrap ── */
  document.addEventListener('click', function (e) {
    closeAll(getWrap(e.target) || undefined);
  });
  document.addEventListener('focusin', function (e) {
    closeAll(getWrap(e.target) || undefined);
  });

  /* ── Collection sort: auto-submit on change ──
     The visible "Apply" button is the no-JS fallback; hide it once JS runs. */
  document.addEventListener('change', function (e) {
    var select = e.target;
    if (!select.matches || !select.matches('[data-sort-select]')) return;
    if (select.form) select.form.submit();
  });

  function hideSortApply() {
    var buttons = document.querySelectorAll('[data-sort-apply]');
    for (var i = 0; i < buttons.length; i += 1) {
      buttons[i].hidden = true;
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideSortApply);
  } else {
    hideSortApply();
  }
})();
